import baseballChallengeSvg from "@/assets/baseball_challenge.svg";

import { StrikeZone } from "../Tagging/components/shared/VisualizationContainer/visualizations/StrikeZone";
import { ChallengeButton } from "./components/ChallengeButton";
import { CountdownUI } from "./CountdownUI";

interface ChallengeStrikeZoneCardProps {
  containerHeight?: string;
  containerWidth?: string;
  isCountingDown: boolean;
  secondsLeft: number;
}

export const ChallengeStrikeZoneCard = ({
  containerHeight,
  containerWidth,
  isCountingDown,
  secondsLeft,
}: ChallengeStrikeZoneCardProps) => {
  const containerStyle =
    containerHeight || containerWidth
      ? { height: containerHeight, width: containerWidth }
      : { height: "19.3rem", minWidth: "340px" };

  if (isCountingDown) {
    return (
      <div
        className="flex flex-col items-center justify-center rounded bg-white shadow-md"
        style={containerStyle}
      >
        <CountdownUI secondsLeft={secondsLeft} size="small" />
      </div>
    );
  }

  return (
    <div
      className="flex flex-col items-stretch justify-start gap-3 rounded bg-white shadow-md p-3"
      style={containerStyle}
    >
      <div className="flex min-h-0 flex-1 items-center justify-center w-full">
        <StrikeZone perspective="catcher" twoStrikeZone={false} />
      </div>
      <div className="flex w-full shrink-0 items-center justify-between rounded bg-gray-100 px-4 py-3">
        <div className="flex items-center gap-2">
          <img
            src={baseballChallengeSvg}
            alt="Challenge"
            className="h-4 w-auto"
          />
          <span className="text-xs font-semibold text-text-light">
            Challenge the pitch?
          </span>
        </div>
        <ChallengeButton size="sm" />
      </div>
    </div>
  );
};
